import { isAfter } from 'date-fns';

const handleUntilEventStarts = ({ page, now }) => {
  if (!page || page.eventDetails == null || page.eventDetails?.startDate == null) {
    return false;
  }

  const eventStartDate = new Date(page.eventDetails.startDate);
  return isAfter(eventStartDate, now);
};

export default handleUntilEventStarts;
